module.exports = __webpack_public_path__ + "img/frame (123).5b890853.jpg";